import React from 'react';

const ResuscitationAndRescue = () => {
  return (
    <div>
      <h1>Resuscitation and Rescue</h1>
      <h2>Health & Safety procedures</h2>
      <p>Click on instructional videos to play….</p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Gs1V2TytPE4"
        title="YouTube video player 1"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <p>Resuscitation - 2 Person</p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Gs1V2TytPE4"
        title="YouTube video player 2"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <p>Board rescue</p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/5eTSHTeHZRQ"
        title="YouTube video player 3"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <p>Resuscitation 4 Person including Oxy Viva and Defib</p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default ResuscitationAndRescue;
